import { createSlice } from "@reduxjs/toolkit";
import { addContent, editContent, getContent, getContentList } from "../services/content-services";



const initialState = {
  contents: [],
  content: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const contentSlice = createSlice({
  name: "content",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContentList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getContentList.fulfilled, (state, action) => {
        state.contents = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getContentList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getContent.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getContent.fulfilled, (state, action) => {
        state.contents = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getContent.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addContent.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addContent.fulfilled, (state, action) => {
        state.contents = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addContent.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editContent.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editContent.fulfilled, (state, action) => {
        state.contents = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editContent.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      
  },
});
export const { resetSuccess, resetState, resetError } = contentSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default contentSlice.reducer;
